// fetchAuthSession, AuthSession, JWT, JwtPayload
import { getAuthState } from '../hooks/useAuth';

let auth = getAuthState()

export default interface Permissions {
    ops: boolean,
    ops_individual: boolean,
    ops_semelhanca: boolean,
    ops_geracao: boolean,
    ops_geracao_ia: boolean,
    ops_historico: boolean,
    ops_integracoes: boolean,
    ops_tech: boolean,
    ops_gpt: boolean,
    ops_enriquecimento: boolean,

    aiv: boolean,
    aiv_configuracao: boolean,
    aiv_tarefa: boolean,
    aiv_crm: boolean,
    aiv_equipes: boolean,
    aiv_analytics: boolean,
    aiv_chat: boolean,
    aiv_free_chat: boolean,

    analytics: boolean,
    analytics_venda: boolean,
    analytics_icpmap: boolean,
    analytics_funnelmap: boolean,

    /** 🤖 AI_FEATURE_FLAG — Controls visibility of all AI/LLM-powered Sales features (insights, anomaly detection, etc.) */
    sales_ai: boolean,

    administrativo: boolean,
    dev: boolean
}

export const initialPermissions: Permissions = {
    ops: false,
    ops_individual: false,
    ops_semelhanca: false,
    ops_geracao: false,
    ops_geracao_ia: false,
    ops_historico: false,
    ops_integracoes: false,
    ops_tech: false,
    ops_gpt: false,
    ops_enriquecimento: false,

    aiv: false,
    aiv_configuracao: false,
    aiv_tarefa: false,
    aiv_crm: false,
    aiv_equipes: false,
    aiv_analytics: false,
    aiv_chat: false,
    aiv_free_chat: false,

    analytics: false,
    analytics_venda: false,
    analytics_icpmap: false,
    analytics_funnelmap: false,

    /** 🤖 AI_FEATURE_FLAG */
    sales_ai: false,

    administrativo: false,
    dev: false
};

export async function checkUserPermissions(): Promise<Permissions> {
    try {
        // const session: AuthSession = await fetchAuthSession() ?? {};
        // const idToken: JWT = session.tokens?.idToken || { 'payload': { 'cognito:groups': [] } };
        // const payload: JwtPayload = idToken.payload;
        // payload['cognito:groups']?.includes('admin') ?? false -> extrair grupos
        auth = getAuthState()
        const payload = auth.customAttributes;
        const access = 'Access' in payload ? JSON.parse(typeof payload['Access'] === 'string' ? payload['Access'] : '') : {
            ops: 'ops-busca' in payload && payload['ops-busca'] === "1",
            ops_individual: 'ops-busca' in payload && payload['ops-busca'] === "1",
            ops_semelhanca: 'ops-busca' in payload && payload['ops-busca'] === "1",
            ops_geracao: 'ops-busca' in payload && payload['ops-busca'] === "1",
            ops_geracao_ia: false,
            ops_historico: 'ops-historico' in payload && payload['ops-historico'] === "1",
            ops_integracoes: 'integracoes' in payload && payload['integracoes'] === "1",
            ops_tech: 'ops-tech' in payload && payload['ops-tech'] === "1",
            ops_gpt: 'ops-gpt' in payload && payload['ops-gpt'] === "1",
            ops_enriquecimento: 'ops-busca' in payload && payload['ops-busca'] === "1",
        
            aiv: 'AIV' in payload && payload['AIV'] === "1",
            aiv_configuracao: 'AIV' in payload && payload['AIV'] === "1",
            aiv_tarefa: 'AIV' in payload && payload['AIV'] === "1",
            aiv_crm: false,
            aiv_equipes: false,
            aiv_analytics: 'AIV' in payload && payload['AIV'] === "1",
            aiv_chat: false,
            aiv_free_chat: false,
        
            analytics: 'analytics' in payload && payload['analytics'] === "1",
            analytics_venda: 'analytics' in payload && payload['analytics'] === "1",
            analytics_icpmap: 'analytics' in payload && payload['analytics'] === "1",
            analytics_funnelmap: 'analytics' in payload && payload['analytics'] === "1",

            sales_ai: false,  // 🤖 AI_FEATURE_FLAG — Off by default for legacy users

            administrativo: 'adm' in payload && payload['adm'] === "1" 
        }

        console.log(payload);

        return access;

    } catch (error) {
        console.error('Erro ao verificar permissões do usuário:', error);
        return initialPermissions;
    }
}
